import React from 'react';
import PropTypes from 'prop-types';
import { Field, ProgressBar } from '@fluentui/react-components';
import "./download-data-modal.scss";

/**
 * Renders the progress bar + status messages for a download operation.
 * @param {string}  downloadStatus  ('pending', 'success', 'error', or null)
 * @param {number}  progressValue   A number from 0 to 1 for the ProgressBar
 */
const DownloadProgressBar = ({ downloadStatus, progressValue }) => {
  let mainMessage = 'Please do not close the window while TRIYO downloads';
  let validationMessage = '';
  let validationState = 'none'; // "none" | "success" | "error" | "warning"
  let color = 'brand';          // "brand" | "success" | "error" | "warning"

  switch (downloadStatus) {
    case 'pending':
      mainMessage = 'Please do not close the window while TRIYO downloads';
      validationMessage = 'We will be done in just a moment';
      validationState = 'none';
      color = 'brand';
      break;

    case 'success':
      mainMessage = 'Download success!';
      validationMessage = 'Dashboard data downloaded successfully';
      validationState = 'success';
      color = 'success';
      break;

    case 'error':
      mainMessage = 'Download failed!';
      validationMessage = 'An error occurred retrieving the data';
      validationState = 'error';
      color = 'error';
      break;

    default:
      mainMessage = 'Please do not close the window while TRIYO downloads';
      validationMessage = '';
      validationState = 'none';
      color = 'brand';
      break;
  }

  return (
    <>
      <p className="download-data-text">
        {mainMessage}
      </p>
      <Field style={{ textAlign: 'center' }}
        className="download-progress-bar"
        validationMessage={validationMessage}
        validationState={validationState}
      >
        <ProgressBar style={{ textAlign: 'center' }}
          className="download-progress-bar"
          value={ downloadStatus === 'success' ? 1 : progressValue}
          color={color}
        />
      </Field>
    </>
  );
};

DownloadProgressBar.propTypes = {
  downloadStatus: PropTypes.oneOf(['pending', 'success', 'error', null]),
  progressValue: PropTypes.number
};

DownloadProgressBar.defaultProps = {
  downloadStatus: null,
  progressValue: 0
};

export default DownloadProgressBar;
